import appeal from './appeal/appeal.module';
import component from './bulkActions.component';
import contact from './contact/contact.module';
import tag from './tag/tag.module';

export default angular.module('mpdx.contacts.list.bulkActions', [component, appeal, contact, tag]).name;
